import * as Dialog from "@radix-ui/react-dialog";
import { Link, useNavigate } from "@tanstack/react-router";
import { ReactComponent as CloseIcon } from "assets/img/icons/header/close.svg";
import { Separator } from "components/elements";

type ReferencesModalProps = {
    isOpen: boolean;
    setIsOpen: (isOpen: boolean) => void;
    discussionIds: {
        id: number;
        title: string;
        date?: string | null;
    }[];
};

export const ReferencesModal = ({ isOpen, setIsOpen, discussionIds }: ReferencesModalProps) => {
    const navigate = useNavigate();
    return (
        <Dialog.Root open={isOpen} onOpenChange={setIsOpen}>
            <Dialog.Portal>
                <Dialog.Overlay className="fixed inset-0 z-50 bg-[#424242]/75 " />
                <Dialog.Content
                    onOpenAutoFocus={(e) => e.preventDefault()}
                    className="fixed left-1/2 top-1/2 z-50 w-full max-w-sm -translate-x-1/2 -translate-y-1/2 overflow-hidden rounded-2xl bg-white p-4"
                >
                    <div className="mb-0 flex items-center justify-between">
                        <Dialog.Title className="mb-3 font-sans text-[24px] font-bold text-[#424242]">
                            Document References
                        </Dialog.Title>
                        <Dialog.Close asChild>
                            <button className="">
                                <CloseIcon className="-mt-2 h-[30px] w-[30px]" />
                            </button>
                        </Dialog.Close>
                    </div>
                    <Separator className="-mx-[16px] mb-5" />
                    <div className="flex w-full flex-col gap-2 space-y-2">
                        {discussionIds.map((discussion, index) => (
                            <Link
                                key={index}
                                to="/discussions"
                                search={{ id: discussion.id }}
                                target="_blank"
                                className="rounded border py-3 px-3 text-sm text-gray-700 no-underline shadow-sm hover:bg-[#f7fbfc]"
                            >
                                {discussion.title}
                            </Link>
                        ))}
                    </div>
                </Dialog.Content>
            </Dialog.Portal>
        </Dialog.Root>
    );
};
